/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { DynamicIconProps } from '../../../icon/icon.types';
import { Icon } from '../../icon';

const Compare24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 15.9997C0.447715 15.9997 5.30357e-08 15.552 5.96216e-08 14.9997C6.62075e-08 14.4475 0.447715 13.9997 1 13.9997L14.5859 13.9997L12.293 11.7068C11.9024 11.3163 11.9024 10.6832 12.293 10.2927C12.6835 9.90219 13.3165 9.90219 13.707 10.2927L17.707 14.2927C17.8946 14.4803 18 14.7345 18 14.9997C18 15.265 17.8946 15.5192 17.707 15.7068L13.707 19.7068L13.6309 19.7751C13.2381 20.0955 12.6591 20.0729 12.293 19.7068C11.9269 19.3407 11.9043 18.7617 12.2246 18.3689L12.293 18.2927L14.5859 15.9997L1 15.9997ZM17 5.99975L3.41406 5.99975L5.70703 8.29272C6.09756 8.68324 6.09756 9.31625 5.70703 9.70678C5.31651 10.0973 4.68349 10.0973 4.29297 9.70678L0.292969 5.70678L0.226563 5.63354C0.080728 5.45558 1.76103e-07 5.23184 1.7887e-07 4.99975C1.82033e-07 4.73453 0.105433 4.48025 0.292969 4.29272L4.29297 0.292715L4.36914 0.224356C4.76191 -0.0959968 5.34091 -0.0734004 5.70703 0.292715C6.07315 0.658833 6.09574 1.23783 5.77539 1.63061L5.70703 1.70678L3.41406 3.99975L17 3.99975C17.5523 3.99975 18 4.44746 18 4.99975C18 5.55203 17.5523 5.99975 17 5.99975Z"
      fill="#0E0E0E"
    />
  </svg>
);

const SIZE_MAP = {
  sm: Compare24,
  md: Compare24,
  lg: Compare24,
  xl: Compare24,
  xxl: Compare24,
  xxxl: Compare24,
};

export const CompareIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: DynamicIconProps) => {
  return (
    <Icon
      data-testid={testId || 'compare-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
